import {CustomerAdvancedSearchResultResponseBody} from '../types';

export const customerAdvancedSearchMock: CustomerAdvancedSearchResultResponseBody[] = [
  {
    id: '18cd8a60-258b-4974-9a6c-42953effe617',
    discriminator: 'NATURAL_PERSON',
    businessAddress: null,
    vatNumber: null,
    vatNumberHighlight: null,
    vatNumberMatchType: 'NONE',
    registrationNumber: '8AK5815',
    registrationNumberHighlight: null,
    registrationNumberMatchType: 'NONE',
    tradeName: null,
    tradeNameHighlight: null,
    tradeNameMatchType: 'NONE',
    foundingPerson: {
      id: '759c1d7b-d52e-477b-b21b-290ed445d3ed',
      hasMatch: true,
      firstName: 'Jan',
      firstNameHighlight: 'Jan',
      firstNameMatchType: 'NONE',
      lastName: 'Zakaznik',
      lastNameHighlight: 'Zakaznik',
      lastNameMatchType: 'NONE',
      email: '2906028@generated.com',
      emailHighlight: null,
      emailMatchType: 'NONE',
      phone: '+420 123 123 123',
      phoneHighlight: '<em>+420 123 123 123</em>',
      phoneMatchType: 'FULL',
      address: null,
    },
    hasMatchInContacts: false,
    contacts: [],
  },
  {
    id: '587240a5-db8e-4d25-93e3-4190cc311596',
    discriminator: 'NATURAL_PERSON',
    businessAddress: null,
    vatNumber: null,
    vatNumberHighlight: null,
    vatNumberMatchType: 'NONE',
    registrationNumber: null,
    registrationNumberHighlight: null,
    registrationNumberMatchType: 'NONE',
    tradeName: null,
    tradeNameHighlight: null,
    tradeNameMatchType: 'NONE',
    foundingPerson: {
      id: '587240a5-db8e-4d25-93e3-4190cc311595',
      hasMatch: false,
      firstName: 'Vojtěch',
      firstNameHighlight: 'Vojtěch',
      firstNameMatchType: 'NONE',
      lastName: 'Veselý',
      lastNameHighlight: 'Veselý',
      lastNameMatchType: 'NONE',
      email: '29033028@generated.com',
      emailHighlight: '2906028@generated.com',
      emailMatchType: 'NONE',
      phone: null,
      phoneHighlight: null,
      phoneMatchType: 'NONE',
      address: null,
    },
    hasMatchInContacts: true,
    contacts: [
      {
        id: '6d5264a5-0ab1-463d-857d-2249675c6937',
        hasMatch: true,
        firstName: 'Marek',
        firstNameHighlight: 'Marek',
        firstNameMatchType: 'NONE',
        lastName: 'Jan',
        lastNameHighlight: '<em>Jan</em>',
        lastNameMatchType: 'FULL',
        email: null,
        emailHighlight: null,
        emailMatchType: 'NONE',
        phone: null,
        phoneHighlight: null,
        phoneMatchType: 'NONE',
        address: null,
      },
    ],
  },
  {
    id: '168ab854-4fe5-45ff-9eb5-5f1378b899d7',
    discriminator: 'NATURAL_PERSON',
    businessAddress: null,
    vatNumber: null,
    vatNumberHighlight: null,
    vatNumberMatchType: 'NONE',
    registrationNumber: null,
    registrationNumberHighlight: null,
    registrationNumberMatchType: 'NONE',
    tradeName: null,
    tradeNameHighlight: null,
    tradeNameMatchType: 'NONE',
    foundingPerson: {
      id: '362a3966-62f6-437e-83bf-50fc4a8ad98e',
      hasMatch: true,
      firstName: 'Hrdý',
      firstNameHighlight: 'Hrdý',
      firstNameMatchType: 'NONE',
      lastName: 'Jan',
      lastNameHighlight: '<em>Jan</em>',
      lastNameMatchType: 'FULL',
      email: 'jan.hrdy@carvago.com',
      emailHighlight: 'jan.hrdy@carvago.com',
      emailMatchType: 'NONE',
      phone: null,
      phoneHighlight: null,
      phoneMatchType: 'NONE',
      address: null,
    },
    hasMatchInContacts: false,
    contacts: [],
  },
  {
    id: '587240a5-db8e-4d25-93e3-4190cc311593',
    discriminator: 'NATURAL_PERSON',
    businessAddress: null,
    vatNumber: null,
    vatNumberHighlight: null,
    vatNumberMatchType: 'NONE',
    registrationNumber: null,
    registrationNumberHighlight: null,
    registrationNumberMatchType: 'NONE',
    tradeName: null,
    tradeNameHighlight: null,
    tradeNameMatchType: 'NONE',
    foundingPerson: {
      id: '587240a5-db8e-4d25-93e3-4190cc311593',
      hasMatch: false,
      firstName: 'Vojtěch',
      firstNameHighlight: 'Vojtěch',
      firstNameMatchType: 'NONE',
      lastName: 'Veselý',
      lastNameHighlight: 'Veselý',
      lastNameMatchType: 'NONE',
      email: '2906028@generated.com',
      emailHighlight: '2906028@generated.com',
      emailMatchType: 'NONE',
      phone: '+420 123 123 123',
      phoneHighlight: '<em>+420 123 123 123</em>',
      phoneMatchType: 'NONE',
      address: null,
    },
    hasMatchInContacts: true,
    contacts: [
      {
        id: '6d5264a5-0ab1-463d-857d-2249675c6937',
        hasMatch: true,
        firstName: 'Marek',
        firstNameHighlight: 'Marek',
        firstNameMatchType: 'NONE',
        lastName: 'Jan',
        lastNameHighlight: '<em>Jan</em>',
        lastNameMatchType: 'FULL',
        email: null,
        emailHighlight: null,
        emailMatchType: 'NONE',
        phone: null,
        phoneHighlight: null,
        phoneMatchType: 'NONE',
        address: null,
      },
    ],
  },
  {
    id: '32827e5c-2992-44d9-adeb-0789f29e2a2b',
    discriminator: 'NATURAL_PERSON',
    businessAddress: null,
    vatNumber: null,
    vatNumberHighlight: null,
    vatNumberMatchType: 'NONE',
    registrationNumber: null,
    registrationNumberHighlight: null,
    registrationNumberMatchType: 'NONE',
    tradeName: null,
    tradeNameHighlight: null,
    tradeNameMatchType: 'NONE',
    foundingPerson: {
      id: '77f37ad3-1105-4afb-b10f-e229c8f93778',
      hasMatch: true,
      firstName: 'Hrdý',
      firstNameHighlight: 'Hrdý',
      firstNameMatchType: 'NONE',
      lastName: 'Jan',
      lastNameHighlight: '<em>Jan</em>',
      lastNameMatchType: 'FULL',
      email: 'jan.hrdy@caravago.com',
      emailHighlight: 'jan.hrdy@caravago.com',
      emailMatchType: 'NONE',
      phone: null,
      phoneHighlight: null,
      phoneMatchType: 'NONE',
      address: null,
    },
    hasMatchInContacts: false,
    contacts: [],
  },
  {
    id: 'b7f83d8c-10fa-4b19-bc4a-9b6578c7a55d',
    discriminator: 'NATURAL_PERSON',
    businessAddress: null,
    vatNumber: null,
    vatNumberHighlight: null,
    vatNumberMatchType: 'NONE',
    registrationNumber: null,
    registrationNumberHighlight: null,
    registrationNumberMatchType: 'NONE',
    tradeName: null,
    tradeNameHighlight: null,
    tradeNameMatchType: 'NONE',
    foundingPerson: {
      id: '870fb04c-163d-4169-b309-8d83bf4ddd32',
      hasMatch: true,
      firstName: 'Petr',
      firstNameHighlight: 'Petr',
      firstNameMatchType: 'NONE',
      lastName: 'Zkousec Jan',
      lastNameHighlight: 'Zkousec <em>Jan</em>',
      lastNameMatchType: 'FULL',
      email: null,
      emailHighlight: null,
      emailMatchType: 'NONE',
      phone: '+420 739 525 292',
      phoneHighlight: '+420 739 525 292',
      phoneMatchType: 'NONE',
      address: null,
    },
    hasMatchInContacts: false,
    contacts: [],
  },
  {
    id: '16b40b98-494d-411b-803e-9c2cbc2656f7',
    discriminator: 'BUSINESS',
    businessAddress: null,
    vatNumber: 'CZ27082440',
    vatNumberHighlight: 'CZ27082440',
    vatNumberMatchType: 'NONE',
    registrationNumber: '27082440',
    registrationNumberHighlight: '27082440',
    registrationNumberMatchType: 'NONE',
    tradeName: 'Jan',
    tradeNameHighlight: '<em>Jan</em>',
    tradeNameMatchType: 'FULL',
    foundingPerson: null,
    hasMatchInContacts: false,
    contacts: [
      {
        id: '292d203e-7dac-43dc-a507-ed22028556d6',
        hasMatch: false,
        firstName: null,
        firstNameHighlight: null,
        firstNameMatchType: 'NONE',
        lastName: null,
        lastNameHighlight: null,
        lastNameMatchType: 'NONE',
        email: 'nemam@km.cz',
        emailHighlight: 'nemam@km.cz',
        emailMatchType: 'NONE',
        phone: '+420 721 333 111',
        phoneHighlight: '+420 721 333 111',
        phoneMatchType: 'NONE',
        address: null,
      },
    ],
  },
  {
    id: 'db7489e2-1c9d-4065-a8cc-79944d4386ad',
    discriminator: 'BUSINESS',
    businessAddress: {
      street: 'J.V.Sládka 91213',
      descriptiveNumber: '12',
      orientationNumber: '213',
      city: 'Teplice',
      zip: '41201',
      addressComplement: null,
      country: 'CZE',
      prefix: null,
      district: null,
      state: null,
      postal: null,
      coordinates: null,
      externalAddressId: null,
    },
    vatNumber: 'EM58478785',
    vatNumberHighlight: 'EM58478785',
    vatNumberMatchType: 'NONE',
    registrationNumber: 'Jan',
    registrationNumberHighlight: 'Jan',
    registrationNumberMatchType: 'NONE',
    tradeName: 'Jan',
    tradeNameHighlight: '<em>Jan</em>',
    tradeNameMatchType: 'FULL',
    foundingPerson: null,
    hasMatchInContacts: false,
    contacts: [
      {
        id: '70212403-06ca-4ced-bcb5-edd68e948572',
        hasMatch: false,
        firstName: 'Jan',
        firstNameHighlight: 'Jan',
        firstNameMatchType: 'NONE',
        lastName: 'Vrábel',
        lastNameHighlight: 'Vrábel',
        lastNameMatchType: 'NONE',
        email: null,
        emailHighlight: null,
        emailMatchType: 'NONE',
        phone: '+420 721 843 236',
        phoneHighlight: '+420 721 843 236',
        phoneMatchType: 'NONE',
        address: {
          street: 'J.V.Sládka',
          descriptiveNumber: '',
          orientationNumber: '',
          city: 'Teplice',
          zip: '664 47',
          addressComplement: null,
          country: 'CZE',
          prefix: null,
          district: null,
          state: null,
          postal: null,
          coordinates: null,
          externalAddressId: null,
        },
      },
    ],
  },
];
